import { cx } from '../../lib/cx';
import type { AppShellProps } from '../types';

/**
 * Sidebar + header + scrolling content. On small screens the sidebar slides over the content
 * and a backdrop closes it.
 */
export const AppShell = ({
  sidebar,
  header,
  children,
  navigationOpen = false,
  onCloseNavigation,
}: AppShellProps) => (
  <div className="flex h-screen overflow-hidden bg-gray-50">
    <div className="hidden md:block">{sidebar}</div>
    {navigationOpen ? (
      <div className="fixed inset-0 z-40 flex md:hidden">
        <div
          className="absolute inset-0 bg-gray-900/40"
          onClick={onCloseNavigation}
          aria-hidden="true"
        />
        <div className="relative z-10 h-full">{sidebar}</div>
      </div>
    ) : null}
    <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
      {header}
      <main className={cx('flex-1 overflow-y-auto p-4 md:p-6')}>{children}</main>
    </div>
  </div>
);
